/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';

/** Styling */
const accordionBaseCss = css({
  flex: 1,
  overflow: 'hidden',
});

const getAccordionContentCss = (isOpen: boolean) => {
  const accordionOpenCss = css({
    transition: `max-height ${
      isOpen ? '0.8s' : '0.4s'
    } cubic-bezier(0.65, 0.05, 0.36, 1)`,
    maxHeight: isOpen ? '400vh' : '0',
  });
  const accordionCss = css(accordionBaseCss, accordionOpenCss);
  return accordionCss;
};

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
}

export default function AccordionContent(props: Props) {
  return (
    <section css={getAccordionContentCss(props.isOpen)}>
      <div>{props.children}</div>
    </section>
  );
}
